import {useState,useEffect} from 'react'
import { useLocation } from 'react-router-dom';



function useCordinates() {
    const [cordinates,setCordinates] = useState(null);
	useEffect(()=>{
		console.log("calling again");
		if(navigator.geolocation){
			navigator.geolocation.getCurrentPosition(_position=>{
				console.log(_position)
				setCordinates(_position.coords);
			},error =>{
				console.log(error);
				return null;
			},{enableHighAccuracy: true},
			)
		}
	},[])
    return cordinates;
}

export default useCordinates
{/*
{maximumAge: 120000,enableHighAccuracy: true}
*/}